var exports = {
  "EyebrowBanner": "EyebrowBanner__drKxii",
  "EyebrowBanner__image": "EyebrowBanner__image__vQjQKN",
  "EyebrowBanner__text": "EyebrowBanner__text__IAZIMJ",
};

__webpack_require__.r(module.exports = exports);
